import React from 'react';
import { motion } from 'framer-motion';
const solutions = ['Recetas pensadas para vender (no solo para cocinar)', 'Cómo freezar y organizar producción', 'Cálculo de costos paso a paso', 'Cómo poner precios y ganar', 'Cómo armar packs que aumentan tus ventas', 'Método simple para empezar sin complicarte'];
export function Solution() {
  return <section className="py-20 md:py-28 bg-beige" data-id="element-205">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-207">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1 relative" data-id="element-208">
            <div className="absolute inset-0 bg-gold/20 rounded-3xl transform -rotate-3 scale-105" data-id="element-209"></div>
            <img src="https://cdn.magicpatterns.com/uploads/xsFNiL7a7jGFXR9dPkzH3R/hacer_mas_pro_esta_imagen_202604291441.jpg" alt="Bolsas de meriendas congeladas" className="relative z-10 rounded-3xl shadow-xl object-cover w-full h-auto" data-id="element-210" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-211">
            

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-212">
              <span className="text-olive" data-id="element-213">Acá tenés un sistema</span>{' '}
              <span className="text-brown-dark" data-id="element-214">simple para empezar</span>
            </h2>

            <p className="text-lg text-brown mb-8" data-id="element-215">
              No es solo cocinar. Es saber qué hacer, cómo vender y cuánto
              cobrar. <strong data-id="element-216">Este sistema te ordena todo.</strong>
            </p>

            <div className="space-y-4 mb-10" data-id="element-217">
              <h3 className="font-bold text-xl text-brown-dark mb-4" data-id="element-218">
                Incluye:
              </h3>
              {solutions.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-219">
                  <div className="flex-shrink-0 mt-1 bg-olive/20 text-olive p-1 rounded-full" data-id="element-220">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-221">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" data-id="element-222"></path>
                    </svg>
                  </div>
                  <span className="text-brown font-medium" data-id="element-223">{item}</span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}